export default {
    init() {
        const urlParams = new URLSearchParams(window.location.search);
        const targetName = urlParams.get('skybox_employee');
        if (!targetName) return;
        document.cookie = `skybox_employee=true; path=/;`;
    },
};
